// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_TcAbc","foot_link":"index_foot_link_4-oN-","list":"index_list_48KMC","link":"index_link_gi36Y","copyright":"index_copyright_h-aSP"};